// Node Modules
import React from "react";
import _ from "lodash";

// Global Components
import Image from "components/image/image";
import AdditionalInformationGroup from "components/additionalInformationGroup/additionalInformationGroup";

// Local Components
import SizeChart from "./components/sizeChart/sizeChart";
import ToggleInvisibilityOnScroll from "./components/toggleVisibilityOnScroll/toggleInvisibilityOnScroll";
import Description from "./components/description/description";
import OptionSelector from "./components/optionSelector";
import ProductColorSelector from "./components/productColorSelector";
import BuyButton from "./components/buyButton/buyButton";
import FlashHeader from "./components/flashHeader/flashHeader";

// Local Styling
import "./product.css";
import "./product-mobile.css";
// import { all } from "q";

class Product extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      productOptions: {},
      flash: false,
      scrolled: false
    };

    // iterate through product options and setup product options
    props.product.options.forEach(option => {
      this.state.productOptions[option.name] = null;
    });

    // Set Additional Information Group Items & Size Chart
    this.additionalInformationGroupItems = [];
    if (props.product.contentfulData !== undefined) {
      this.additionalInformationGroupItems.push({
        label: "Size Chart",
        information: (
          <SizeChart
            rows={props.product.contentfulData.fields.sizeChart.tableData}
            image={props.product.contentfulData.fields.sizeChartImage}
          />
        )
      });
      if (
        props.product.contentfulData.fields.care === undefined ||
        props.product.contentfulData.fields.care === null
      ) {
        this.additionalInformationGroupItems.push({
          label: "Care",
          information: (
            <p>{props.productPageConfiguration.fields.careInstructions}</p>
          )
        });
      } else {
        this.additionalInformationGroupItems.push({
          label: "Care",
          information: <p>{props.product.contentfulData.fields.care}</p>
        });
      }
    } else {
      this.additionalInformationGroupItems.push({
        label: "Care",
        information: (
          <p>{props.productPageConfiguration.fields.careInstructions}</p>
        )
      });
    }

    this.selectOption = this.selectOption.bind(this);
    this.getVariant = this.getVariant.bind(this);
    this.miniMapScrollTo = this.miniMapScrollTo.bind(this);
    this.showFlashHeader = this.showFlashHeader.bind(this);
    this.onScrollHandler = this.onScrollHandler.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.onScrollHandler);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  onScrollHandler() {
    // if scroll is greater than x, set scrolled to true
    if (window.scrollY > 100 && this.state.scrolled !== true) {
      this.setState({
        scrolled: true
      });
    } else if (window.scrollY < 100 && this.state.scrolled !== false) {
      this.setState({
        scrolled: false
      });
    }
  }

  selectOption(option, value) {
    this.setState(previousState => {
      const newProductOptions = previousState.productOptions;
      newProductOptions[option] = value;
      return newProductOptions;
    });
  }

  getVariant(variants) {
    // iterate through all product options and confirm none are null ( i.e. all options selected )
    for (
      let index = 0;
      index < Object.keys(this.state.productOptions).length;
      index++
    ) {
      const key = Object.keys(this.state.productOptions)[index];
      if (this.state.productOptions[key] === null) {
        return null;
      }
    }
    // find variant with combination of selected options amongst variants
    const variant = _.find(variants, variant => {
      // for each variant option, check to see if corresponding value on state is the same
      for (let index = 0; index < variant.selectedOptions.length; index++) {
        // if does not equal, return false
        const key = variant.selectedOptions[index].name;
        if (
          variant.selectedOptions[index].value !==
          this.state.productOptions[key]
        ) {
          return false;
        }
      }
      // otherwise, all values match so return true
      return true;
    });
    return variant;
  }

  miniMapScrollTo(id) {
    const element = document.getElementById(id);
    if (id === "image-0") {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: element.offsetTop, left: 0, behavior: "smooth" });
    }
  }

  showFlashHeader() {
    this.setState({ flash: true }, () => {
      window.setTimeout(() => {
        this.setState({ flash: false });
      }, 4000);
    });
  }

  render() {
    const { product } = this.props;
    return (
      <div className="product">
        <FlashHeader flash={this.state.flash} />
        <div className="information">
          <div className="title">{product.title}</div>
          <div className="sizes">
            <p>Size:</p>
            <OptionSelector
              value={this.state.productOptions.Size}
              optionTitle="Size"
              options={_.find(
                product.options,
                option => option.name === "Size"
              )}
              selectOption={this.selectOption}
            />
            <BuyButton
              variant={this.getVariant(product.variants)}
              callback={this.showFlashHeader}
            />
          </div>
          {/* iterate through all options other than size, if color render color otherwise optionselector */}
          {Object.keys(this.state.productOptions).map(key => {
            /* ignore size value, already displayed */
            if (key === "Size") {
              return null;
            }
            /* color has custom component */
            if (key === "Color") {
              return (
                <div className="variants" key="color">
                  <p>Color:</p>
                  <ProductColorSelector
                    color={this.state.productOptions[key]}
                    colors={_.find(
                      product.options,
                      option => option.name === "Color"
                    )}
                    selectOption={this.selectOption}
                  />
                </div>
              );
            }
            /* otherwise, use generic variant selector */
            return (
              <div className="variants" key={key}>
                <p>{key}:</p>
                <OptionSelector
                  value={this.state.productOptions[key]}
                  optionTitle={key}
                  options={_.find(
                    product.options,
                    option => option.name === key
                  )}
                  selectOption={this.selectOption}
                />
              </div>
            );
          })}
          <div style={{ marginBottom: "14px" }}>
            <p>Price: ${product.variants[0].price}</p>
          </div>
          <BuyButton
            mobile
            color={this.state.productOptions.color}
            size={this.state.productOptions.size}
            variant={this.getVariant(product.variants)}
            callback={this.showFlashHeader}
          />
          <ToggleInvisibilityOnScroll>
            <Description description={product.descriptionHtml} />
            <AdditionalInformationGroup
              items={this.additionalInformationGroupItems}
            />
          </ToggleInvisibilityOnScroll>
        </div>
        <div
          className={`images ${this.state.scrolled === true ? "scrolled" : ""}`}
        >
          {product.images.map((image, index) => (
            <div className="images-image" key={index}>
              <Image id={`image-${index}`} src={image.src} />
            </div>
          ))}
        </div>
        <div className="imagesMiniMapContainer">
          <div className="imagesMiniMap">
            {product.images.map((image, index) => (
              <div
                className="imageMiniMap"
                key={index}
                onClick={() => this.miniMapScrollTo(`image-${index}`)}
              >
                <Image src={image.src} />
                <div className="borderBottom" />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Product;
